import {
  auraExplosion,
  auraExplosionLoop,
  blender,
  fbm,
  guestbookSoundtrack,
  introSoundtrack,
  man,
  perlin,
  random,
  screaming1,
  screaming2,
  ubuntuMonoBold,
  ubuntuMonoRegular,
  worksPreAura,
} from "@folio-2026/shared"

export const audioSources = [
  {
    name: "intro-soundtrack",
    path: introSoundtrack,
  },
  {
    name: "screaming-1",
    path: screaming1,
  },
  {
    name: "screaming-2",
    path: screaming2,
  },
  {
    name: "works-pre-aura",
    path: worksPreAura,
  },
  {
    name: "guestbook-soundtrack",
    path: guestbookSoundtrack,
  },
  {
    name: "aura-explosion-loop",
    path: auraExplosionLoop,
  },
  {
    name: "aura-explosion",
    path: auraExplosion,
  },
]

export default [
  {
    name: "fbm",
    type: "texture",
    path: fbm,
  },
  {
    name: "perlin",
    type: "texture",
    path: perlin,
  },
  {
    name: "random",
    type: "texture",
    path: random,
  },
  {
    name: "man",
    type: "gltfModel",
    path: man,
  },
  {
    name: "blender",
    type: "gltfModel",
    path: blender,
  },
  {
    name: "bmfontUbuntuMonoRegular",
    type: "font",
    path: ubuntuMonoRegular.bmfont,
  },
  {
    name: "atlasUbuntuSansMonoRegular",
    type: "texture",
    path: ubuntuMonoRegular.atlas,
  },
  {
    name: "bmfontUbuntuMonoBold",
    type: "font",
    path: ubuntuMonoBold.bmfont,
  },
  {
    name: "atlasUbuntuMonoBold",
    type: "texture",
    path: ubuntuMonoBold.atlas,
  },
]
